import moment from 'moment-timezone'

export default () => {
  return moment
}